import {
	KnowledgeDiscoveryJiraSearchClassification,
	type KnowledgeDiscoveryJiraSearchClassificationType,
} from '@atlassian/search-client';

import { disposableValue } from './disposable-value';

export const IntentMode = KnowledgeDiscoveryJiraSearchClassification;

export type IntentMode = KnowledgeDiscoveryJiraSearchClassificationType;

export type IntentDetection = { mode: IntentMode; query: string; route: string };

export const INTENT_DETECTION = disposableValue<IntentDetection | null>(null);
